import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  hover?: boolean;
}
export function Card({
  children,
  className = '',
  hover = false,
  ...props
}: CardProps) {
  return <div className={`bg-white rounded-lg border border-gray-100 shadow-sm ${hover ? 'transition-all duration-200 hover:shadow-md hover:-translate-y-1 hover:border-[#0af]/30' : ''} ${className}`} {...props} data-id="element-151">
      {children}
    </div>;
}